<form [formGroup]="boardForm" (ngSubmit)="onSubmit()">
  <input [formControl]="boardForm.get('name')" [selectText]="true"/>
</form>
<button a-button (click)="onSubmit()" class="btn_primary" [disabled]="!boardForm.valid">Save</button>
<button a-button (click)="onCancel()" class="btn_text">Cancel</button>
